var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-notification-holder",class:{'is-badge':_vm.badge}},[(_vm.count > 0)?_c('span',{staticClass:"c-notification-holder__counter"},[_vm._v(_vm._s(_vm.displayCount))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }